import { Vue, Component, Prop, Ref, Emit } from 'vue-property-decorator'
import BillingModalEntityGridComponent from '@/modules/billing-module/shared/components/modal-entity/components/grid/billing-modal-entity-grid.vue'
import { BModal } from 'bootstrap-vue/src/components/modal'
import { BillingModalEntityParams } from '@/modules/billing-module/shared/components/modal-entity/billing-modal-entity-model'

@Component({
    components: {
        BillingModalEntityGridComponent
    }
})
export default class BillingModalEntity<T> extends Vue {
    @Prop({ type: Object, required: true }) readonly params!: BillingModalEntityParams<T>

    @Ref() readonly modal!: BModal

    @Emit()
    hideAddToMode(): void {
        // emits an event
    }
    @Emit()
    totalCountChanged(totalCount: number): number {
        return totalCount
    }
    @Emit()
    selectedRowsChanged(selectedRows: T[]): T[] {
        return selectedRows
    }

    /// MODAL ///

    show(): void {
        this.modal.show()
    }
    hide(): void {
        this.modal.hide()
    }
}
